import Grid from '@material-ui/core/Grid';
import GridFormField from 'shared/components/GridFormField';
import React from 'react';
import removeHTML from 'shared/utils/removeHTML';
import Typography from '@material-ui/core/Typography';
import {
	dateInRange,
	isAfterDobCoApp,
	maxStrLength,
	numericValidation,
	phoneNumberValidation,
	settingValidation,
	restrictedTextInputValidation,
} from 'shared/utils/validations';
import { formatNumber, formatPhone, parseNumber, parsePhone } from 'shared/utils/formatting';
import { FormSection } from 'redux-form';
import { PropTypes } from 'prop-types';
import {
	COAPP_CURRENT_EMPLOYMENT,
	DATE_RANGE_START_YEAR,
	DATE_RANGE_START_MONTH,
	DATE_RANGE_START_DAY,
	INCOME_TYPE_OPTIONS,
} from './constants';

const CoAppCurrentEmploymentFields = ({ disableAll, name, settings }) => (
	<FormSection name={name} style={{ width: '100%' }}>
		<Grid container spacing={5}>
			<GridFormField
				fieldSettings={settings.coApp.employer}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmployerLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmployerDescription}
				name="name"
				validation={[
					settingValidation(settings.coApp.employer),
					maxStrLength(30),
					restrictedTextInputValidation,
				]}
				disabled={disableAll}
			/>
			<GridFormField
				fieldSettings={settings.coApp.jobTitle}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppJobTitleLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppJobTitleDescription}
				name="jobTitle"
				validation={[settingValidation(settings.coApp.jobTitle), maxStrLength(30)]}
				disabled={disableAll}
			/>
			<GridFormField
				fieldSettings={settings.coApp.employerPhone}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmployerPhoneLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmployerPhoneDescription}
				name="phone"
				validation={[settingValidation(settings.coApp.employerPhone), phoneNumberValidation('US')]}
				format={formatPhone('US')}
				parse={parsePhone('US')}
				disabled={disableAll}
			/>
			<GridFormField
				fieldSettings={settings.coApp.timeAtEmployer}
				validation={[
					settingValidation(settings.coApp.timeAtEmployer),
					dateInRange(
						new Date(DATE_RANGE_START_YEAR, DATE_RANGE_START_MONTH, DATE_RANGE_START_DAY),
						new Date(Date.now()),
					),
					isAfterDobCoApp,
				]}
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmploymentStartLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppEmploymentStartDescription}
				type="date"
				inputProps={{ 
					style: { textTransform: 'uppercase', marginTop: '16px' },
					placeholder: 'MM/dd/yyyy' }}
				labelShrink
				name="employmentTermStartDate"
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppIncomeLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppIncomeDescription}
				fieldSettings={settings.coApp.income}
				name="income"
				validation={[settingValidation(settings.coApp.income), maxStrLength(6), numericValidation]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppIncomeTypeLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppIncomeTypeDescription}
				fieldSettings={settings.coApp.incomeIndicator}
				select
				menuOptions={INCOME_TYPE_OPTIONS}
				name="incomeIndicator"
				validation={settingValidation(settings.coApp.incomeIndicator)}
				disabled={disableAll}
			/>
			<GridFormField
				placeholder={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppNetIncomeLabel}
				description={settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppNetIncomeDescription}
				fieldSettings={settings.coApp.netIncome}
				name="netIncome"
				validation={[
					settingValidation(settings.coApp.netIncome),
					maxStrLength(6),
					numericValidation,
				]}
				format={formatNumber}
				parse={parseNumber}
				disabled={disableAll}
			/>
		</Grid>
		<Typography type="caption" component="div" style={{ paddingTop: '20px' }}>
			<div
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{
					__html: removeHTML(settings.fieldAndFooterSettings.ApplicationPageSettings.CoAppCurrentEmploymentFooter),
				}}
			/>
		</Typography>
	</FormSection>
);

CoAppCurrentEmploymentFields.propTypes = {
	disableAll: PropTypes.bool,
	settings: PropTypes.shape({
		primary: PropTypes.objectOf(
			PropTypes.oneOfType([
				PropTypes.shape({
					fieldId: PropTypes.string,
					fieldStatus: PropTypes.string,
					fieldSubHeaderType: PropTypes.string,
				}),
				PropTypes.number,
			]),
		),
	}),
	name: PropTypes.string,
};

CoAppCurrentEmploymentFields.defaultProps = {
	disableAll: false,
	settings: {},
	name: COAPP_CURRENT_EMPLOYMENT,
};

export default CoAppCurrentEmploymentFields;
